import { get } from 'object-path';
import {
  OPTIONS_CANCELLED,
  OPTIONS_ERROR_FROM_REMOTE,
  OPTIONS_GET,
  OPTIONS_SUCCESS,
} from '../actions/options';
import { optionsStateSelector } from '../selectors/options';
import { getResponsePayload } from './fetch';

const performRemoteFetch = async (settings) => {
  const {
    url,
    query,
    pathOptions,
    pathValue = 'value',
    pathLabel = 'label',
    authorization,
    supplierID,
  } = settings;

  const fetchOptions = {
    headers: new Headers(),
  };
  if (authorization) {
    fetchOptions.headers.set('Authorization', authorization);
  }
  if (supplierID) {
    fetchOptions.headers.set('IdWorker', supplierID);
  }
  const response = await fetch(url.replace('{query}', query), fetchOptions);
  const json = await getResponsePayload(response);
  let items = [];
  if (pathOptions) {
    items = get(json, pathOptions, []);
  } else if (Array.isArray(json)) {
    items = json;
  }
  const options = items.map((item) => ({
    value: get(item, pathValue),
    label: get(item, pathLabel),
  }));
  return options;
};

const fetchRemoteOptionsFromSettings = async (settings) => {
  return performRemoteFetch(settings);
};

const optionsMiddleware = ({ getState, dispatch }) => {
  return (next) => async (action) => {
    if (action.type !== OPTIONS_GET) {
      return next(action);
    }

    const alreadyInState = optionsStateSelector(action.payload)(getState());
    next(action);

    if (alreadyInState) {
      // If existing options are found for a previous equivalent action,
      // we remove the pending reducer object generated by the current action
      dispatch({
        type: OPTIONS_CANCELLED,
        fetchId: action.fetchId,
      });
      return;
    }

    try {
      const options = await performRemoteFetch(action.payload);
      dispatch({
        type: OPTIONS_SUCCESS,
        fetchId: action.fetchId,
        options,
      });
    // eslint-disable-next-line no-unused-vars
    } catch (error) {
      dispatch({
        type: OPTIONS_ERROR_FROM_REMOTE,
        fetchId: action.fetchId,
      });
    }
  };
};

export {
  fetchRemoteOptionsFromSettings,
  optionsMiddleware,
};
